export default __webpack_public_path__ + "static/media/3.ea838295.png";